<div
  class="form-floating {{customClass}}" [ngClass]="{
  'input__container': customInput,
  'input__container--warning': warning,
  }"
  (click)="$event.stopPropagation()"
  *appLet="{
    appCopy: appCopy$ | async,
    isMobile: isMobile$ | async,
    isWeb: isWeb$ | async
  } as $comp"
>
  <ng-container
    *ngIf="$comp.isWeb; then webReactive; else mobileReactive"
  ></ng-container>

  <ng-template #webReactive>
    <select
      (mousedown)="isSelectOpen = true"
      (blur)="isSelectOpen = false"
      [class.open]="isSelectOpen"
      *ngIf="formControl"
      [id]="id"
      class="form-select custom-select"
      [class.input--custom-valid]="customInputValid"
      [class.readonly]="readonly"
      [name]="name"
      attr.data-qa="{{ name + '-select' }}"
      [formControl]="formControl"
      [attr.data-value]="value"
      [required]="required"
      (change)="onChange($event)"
    >
      <ng-container *ngTemplateOutlet="webOptions"></ng-container>
    </select>
    <ng-container *ngTemplateOutlet="selectLabel"></ng-container>
    <ng-container *ngTemplateOutlet="errors"></ng-container>
  </ng-template>

  <ng-template #mobileReactive>
    <select
      *ngIf="formControl"
      [formControl]="formControl"
      [id]="id"
      [name]="name"

      [required]="required"
      attr.disabled="{{ disabled ? '' : null }}"
      (change)="onChange($event)"
    >
      <ng-container *ngTemplateOutlet="mobileOptions"></ng-container>
    </select>
    <ng-container *ngTemplateOutlet="errors"></ng-container>
  </ng-template>
  <ng-template #webOptions>
    @if (showDefault) {
    <option [value]="defaultItem.value">{{ defaultItem.text }}</option>
    }
    <option
      *ngFor="let item of items"
      [value]="valueKey === 'index' ? item : item[valueKey]"
      [selected]="(valueKey === 'index' ? item : item[valueKey]) === value"
    >
      {{ textKey === "index" ? item : item[textKey] }}
    </option>
  </ng-template>

  <ng-template #mobileOptions>
    <option
      *ngFor="let item of items"
      [value]="valueKey === 'index' ? item : item[valueKey]"
    >
      {{ textKey === "index" ? item : item[textKey] }}
    </option>
  </ng-template>

  <ng-template #selectLabel>
    <label *ngIf="label" [for]="id" class="form-label">
      {{ required ? (label | requiredField) : label }}
    </label>
  </ng-template>

  <ng-template #errors>
    @if (!hideErrorLabel) {
      <app-input-errors
        *ngIf="control && $comp.appCopy"
        [control]="control"
        [suppressErrors]="suppressErrors"
        [extraErrors]="extraErrors"
        [errors]="$comp.appCopy.errors"
      ></app-input-errors>
    }
  </ng-template>
</div>
